<template>
  <v-footer id="core-footer" absolute height="82">
    <v-img :src="logo" height="50" contain />
    <span class="font-weight-light copyright pr-4">
      &copy;
      {{ new Date().getFullYear() }}
      innvisi s.r.o.
    </span>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    logo: require("@/assets/img/logo_300x100_transparent.png")
  })
};
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
